export class TheRaveGameMode {
    public static readonly FREESPIN_SUPER:string = "FREESPIN_SUPER";
}